import { Heading } from '@pandiafi/design-system'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Divider } from '../../Divider'
import { localizeCurrency } from '../../utils'
import { FeeRow } from '../FeeRow/FeeRow'

import { formatDate } from 'utils/dateUtils'

interface PaidFeeProps {
  paidAmount: number
  paidDate: string | null
}

export const PaidFee: React.FC<PaidFeeProps> = ({ paidAmount, paidDate }) => {
  const { t } = useTranslation(['payments'])

  return (
    <section>
      <Divider className="mt-6 mb-6" />
      <Heading element="h2" size="m" bold className="mb-2">
        {t('payments:rightOfOccupancyFee.paidTitle')}
      </Heading>
      <FeeRow
        label={t('payments:rightOfOccupancyFee.paidAmount')}
        value={localizeCurrency(paidAmount)}
      />
      <FeeRow
        label={t('payments:rightOfOccupancyFee.paidDate')}
        value={paidDate ? formatDate(paidDate) : '-'}
      />
    </section>
  )
}
